import React, { useEffect, useState } from "react";
import { Button, message, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import OtpInput from "react-otp-input";

import {
  hideMessage,
  showAuthLoader,
  signInCognitoUser,
  verifyUserPhoneNumber,
  initCognitoAuthSession,
  resetAuthStore,
} from "./../appRedux/actions/Auth";

import IntlMessages from "util/IntlMessages";
import CircularProgress from "components/CircularProgress/index";
import PhoneNumber from "../routes/components/dataEntry/Form/PhoneNumber";
import { getAuthincatedCognitoSession } from "../aws/appsync";

const SignIn = ({ location }) => {
  const dispatch = useDispatch();
  const {
    loader,
    alertMessage,
    showMessage,
    authUser,
    sessionInitComplete,
    cognitoUser,
    showOTP,
  } = useSelector(({ auth }) => auth);
  const [form] = Form.useForm();
  const history = useHistory();
  const [otp, setOtp] = useState("");

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 100);
    }
    if (authUser && authUser.username) {
      history.push("/");
    }
  });
  useEffect(() => {
    dispatch(resetAuthStore);
  }, []);
  useEffect(() => {
    async function fetchData() {
      let authSession = null;
      try {
        authSession = await getAuthincatedCognitoSession();
      } catch (error) {
        console.log(error);
      }
      console.log(authSession);
      dispatch(initCognitoAuthSession(authSession));
    }
    !sessionInitComplete && fetchData();
  }, []);
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    console.log("updated url")
    console.log(location.pathname+`?phone=${values.phone}`)
    history.push(location.pathname+`${location.search}&phone=${values.phone}`)
    dispatch(showAuthLoader());
    if (showOTP) {
      return dispatch(verifyUserPhoneNumber({ cognitoUser, otp }));
    }
    dispatch(signInCognitoUser(values));
  };

  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content" style={{overflow:"inherit"}}>
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg">
              <img
                src={require("assets/images/bg-website-final.png")}
                alt="background"
              />
            </div>
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signIn" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              {/* <p><IntlMessages id="app.userAuth.getAccount"/></p> */}
            </div>
            <div className="gx-app-logo">
              <img
                alt="example"
                src={require("assets/images/quiznext-logo-white@2x.png")}
              />
            </div>
          </div>
          <div className="gx-app-login-content">
            <Form
              form={form}
              initialValues={{ phone: "" }}
              name="signInForm"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              {/* <Form.Item
                  initialValue="dashmax"
                  rules={[{ required: true, message: 'The input is not valid E-mail!' }]} name="email">
                  <Input placeholder="Email"/>
                </Form.Item>
                <Form.Item
                  initialValue="123456"
                  rules= {[{required: true, message: 'Please input your Password!'}]}  name="password">
                    <Input type="password" placeholder="Password"/>
                </Form.Item> */}
              {!showOTP && <PhoneNumber formRef={form}/>}
              {showOTP && (
                <div>
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    numInputs={6}
                    separator={<span style={{ padding: "3" }}>-</span>}
                    inputStyle={{
                      minWidth: "30px",
                      minHeight: "30px",
                      marginBottom: 5,
                    }}
                  />
                  {/* <div style={{display:"flex", flexDirection:"row-reverse"}}>
                    <Button type="link">  
                      resend otp to {cognitoUser ? cognitoUser.username : ""}
                    </Button>
                    
                  </div> */}
                </div>
              )}
              {/* <Form.Item name="remember" valuePropName="checked">
                  <Checkbox>Remember me</Checkbox>
                  <Link className="gx-login-form-forgot" to="/custom-views/user-auth/forgot-password">Forgot password</Link>
                </Form.Item> */}
              <Form.Item>
                <Button type="primary" className="gx-mb-0" htmlType="submit">
                  {showOTP ? (
                    <IntlMessages id={"app.userAuth.verifyOtp"} />
                  ) : (
                    "Login"
                  )}
                </Button>
                <span>
                  <IntlMessages id="app.userAuth.or" />
                </span>{" "}
                <Link
                  to="/signup"
                  onClick={() => {
                    dispatch(resetAuthStore());
                  }}
                >
                  Register
                </Link>
              </Form.Item>
            </Form>
          </div>

          {loader ? (
            <div className="gx-loader-view">
              <CircularProgress />
            </div>
          ) : null}
          {showMessage ? message.error(alertMessage.toString(), 5) : null}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
